import { cardContainerStyles } from "@insite/content-library/Components/CardContainer";
import { cartTotalStyles } from "@insite/content-library/Widgets/Cart/CartTotal";
import { orderHistoryTableStyles } from "@insite/content-library/Widgets/OrderHistory/OrderHistoryTable";
import { rfqQuoteDetailsMessagesStyles } from "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsMessages";
import { rfqQuoteDetailsProposedDetailsGridItemStyles } from "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsProposedDetailsGridItem";

import { css } from "styled-components";

cartTotalStyles.submitQuoteButton = {
    css: css`
        width: 100%;
        margin-top: 10px;
        position: inherit;
        left: inherit;
        bottom: inherit;
    `,
};
rfqQuoteDetailsMessagesStyles.mainWrapper = {
    css: css`
        border-radius: 7px;
        border: 1px solid rgb(204, 204, 204);
        box-shadow: rgba(0, 0, 0, 0.1) 0px 3px 5px 0px;
        padding: 10px;
        background-color: #fff;
    `,
};
orderHistoryTableStyles.container = {
    css: css`
        border: 1px solid rgb(204, 204, 204);
        box-shadow: rgba(0, 0, 0, 0.1) 0px 3px 5px 0px;
    `,
};
cardContainerStyles.cardDivider = {
    css: css`
        border: 1px solid rgb(204, 204, 204);
        box-shadow: rgba(0, 0, 0, 0.1) 0px 3px 5px 0px;
        border-radius: 7px;
        background: #fff;
        width: 100%;
        margin-bottom: 10px;
    `,
};
rfqQuoteDetailsProposedDetailsGridItemStyles.container = {
    gap: 20,
    css: css`
        // border: 1px solid rgb(204, 204, 204);
        box-shadow: rgba(0, 0, 0, 0.1) 0px 3px 5px 0px;
        border-radius: 0 7px 7px 0;
        background: #fff;
        width: 100%;
        margin-bottom: 10px;
        padding: 0.5rem 0;
        > div[class^="GridOffset"] {
            padding: 0 10px;
        }
    `,
};
